import { Breadcrumbs, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import * as ROUTES from "../../constants/routes";
import { Link } from "react-router-dom";

const AllAccessories = () => {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb">
        <Typography color="textPrimary">{t("breadcrumbs.allAccessories")}</Typography>
      </Breadcrumbs>
      <Typography variant="h3" color="secondary" style={{ marginTop: 18 }}>
        {t("navigation.accessories")}
      </Typography>
    </>
  );
};

export default AllAccessories;

/**  <Breadcrumbs aria-label="breadcrumb">
      <Typography variant="h5" color="textPrimary">
        {t("navigation.accessories")}
      </Typography>
      <Typography variant="h5" color="textPrimary">
        {t("breadcrumbs.allAccessories")}
      </Typography>
    </Breadcrumbs> */
